import React from 'react';
import {ReactComponent as Star} from './favorites_menu.svg';
import {ReactComponent as SelectedStar} from './favorites_menu_active.svg';

type StarIconProps = {
    selected?: boolean;
};

export const StarIcon: React.FC<StarIconProps> = ({selected}) => selected ? <SelectedStar/> : <Star/>;
